export function detectCedula(file: File, type: string): Promise<string> {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = URL.createObjectURL(file);
        image.onload = () => {
            let src = window.cv.imread(image);
            let gray = new window.cv.Mat();
            let edges = new window.cv.Mat();
            let contours = new window.cv.MatVector();
            let hierarchy = new window.cv.Mat();
            let rect;

            // Convertir la imagen a escala de grises
            window.cv.cvtColor(src, gray, window.cv.COLOR_RGBA2GRAY);

            // Aumentar el contraste mediante ecualización del histograma
            window.cv.equalizeHist(gray, gray);

            // Aplicar desenfoque para reducir el ruido
            window.cv.GaussianBlur(gray, gray, new window.cv.Size(5, 5), 0);

            // Detección de bordes con Canny (ajustar los umbrales si es necesario)
            window.cv.Canny(gray, edges, 50, 150);

            // Aplicar cierre morfológico para unir bordes rotos
            let kernel = window.cv.getStructuringElement(window.cv.MORPH_RECT, new window.cv.Size(5, 5));
            window.cv.morphologyEx(edges, edges, window.cv.MORPH_CLOSE, kernel);

            // Encontrar contornos basados en los bordes detectados
            window.cv.findContours(edges, contours, hierarchy, window.cv.RETR_EXTERNAL, window.cv.CHAIN_APPROX_SIMPLE);

            // Filtrar contornos para encontrar el rectángulo más grande
            let maxArea = 0;
            let largestContour = null;
            for (let i = 0; i < contours.size(); i++) {
                let contour = contours.get(i);
                let area = window.cv.contourArea(contour);
                let approx = new window.cv.Mat();
                window.cv.approxPolyDP(contour, approx, 0.02 * window.cv.arcLength(contour, true), true);

                // Verificar si es rectangular y ocupa una porción significativa de la imagen
                const aspectRatio = Math.abs(approx.rows - 4) < 2;
                if (area > 5000 && aspectRatio && area > maxArea) {
                    maxArea = area;
                    largestContour = approx;
                    rect = window.cv.boundingRect(approx);
                } else {
                    approx.delete();
                }
            }

            if (rect) {
                // Recortar solo la cédula
                rect.x = Math.max(rect.x, 0);
                rect.y = Math.max(rect.y, 0);
                rect.width = Math.min(rect.width, src.cols - rect.x);
                rect.height = Math.min(rect.height, src.rows - rect.y);

                let cropped = src.roi(rect);
                if (rect.width < 300 || rect.width > 401)  {
                console.warn("No se encontró un contorno adecuado se ha enviado la imagen original.");
                // Crear un canvas para mostrar la imagen original
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                canvas.width = image.width;
                canvas.height = image.height;
                ctx?.drawImage(image, 0, 0, image.width, image.height);

                // Convertir la imagen original a Base64
                const base64Image = canvas.toDataURL('image/png');
                resolve(base64Image);
                }
                else{
                    
                // Crear un canvas para mostrar la imagen recortada
                let canvas = document.createElement('canvas');
                canvas.width = rect.width;
                canvas.height = rect.height;
                let ctx = canvas.getContext('2d');
                ctx?.drawImage(image, rect.x, rect.y, rect.width, rect.height, 0, 0, rect.width, rect.height);

                // Convertir la imagen del canvas a Base64
                const base64Image = canvas.toDataURL('image/png');
                resolve(base64Image);

                cropped.delete();
                }
            } else {
                console.warn("No se encontró un contorno adecuado.");

                // Crear un canvas para mostrar la imagen original
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                canvas.width = image.width;
                canvas.height = image.height;
                ctx?.drawImage(image, 0, 0, image.width, image.height);

                // Convertir la imagen original a Base64
                const base64Image = canvas.toDataURL('image/png');
                resolve(base64Image);
            }

            // Limpiar
            src.delete(); gray.delete(); edges.delete();
            contours.delete(); hierarchy.delete();
            largestContour?.delete();
        };

        image.onerror = () => {
            reject(new Error("Error al cargar la imagen."));
        };
    });
}
